export const GET_COMMENT_BOARD = "GET_COMMENT_BOARD"
export const GET_COMMENT_BOARD_SUCCESS = "GET_COMMENT_BOARD_SUCCESS"
export const GET_COMMENT_BOARD_FAILED = "GET_COMMENT_BOARD_FAILED"
export const RESET_COMMENT_BOARD = "RESET_COMMENT_BOARD"

export const UPDATE_COMMENT_BOARD_LAYOUT = "UPDATE_COMMENT_BOARD_LAYOUT"
export const UPDATE_COMMENT_BOARD_LAYOUT_SUCCESS =
  "UPDATE_COMMENT_BOARD_LAYOUT_SUCCESS"
export const UPDATE_COMMENT_BOARD_LAYOUT_FAILED =
  "UPDATE_COMMENT_BOARD_LAYOUT_FAILED"

export const GET_CHAT_USERS = "GET_CHAT_USERS"
export const GET_CHAT_USERS_SUCCESS = "GET_CHAT_USERS_SUCCESS"
export const GET_CHAT_USERS_FAILED = "GET_CHAT_USERS_FAILED"

export const INIT_CHAT_SESSION = "INIT_CHAT_SESSION"
export const SAVE_SESSION = "SAVE_SESSION"
export const SAVE_MESSAGES = "SAVE_MESSAGES"
export const SAVE_DIALOG = "SAVE_DIALOG"
export const NEW_MESSAGE = "NEW_MESSAGE"
export const INIT_CHAT_SESSION_SUCCESS = "INIT_CHAT_SESSION_SUCCESS"
export const RETRIEVE_CHAT_MESSAGES = "RETRIEVE_CHAT_MESSAGES"
export const LOAD_CHAT_MESSAGES = "LOAD_CHAT_MESSAGES"
export const LOAD_CHAT_MESSAGES_SUCCESS = "LOAD_CHAT_MESSAGES_SUCCESS"
export const LOAD_CHAT_MESSAGES_FAILED = "LOAD_CHAT_MESSAGES_FAILED"
export const DELETE_CHAT_MESSAGES = "DELETE_CHAT_MESSAGES"
export const DELETE_CHAT_MESSAGES_SUCCESS = "DELETE_CHAT_MESSAGES_SUCCESS"
export const DELETE_CHAT_MESSAGES_FAILED = "DELETE_CHAT_MESSAGES_FAILED"

export const UPLOAD_IMAGES = "UPLOAD_IMAGES"
export const UPLOAD_IMAGES_SUCCESS = "UPLOAD_IMAGES_SUCCESS"
export const UPLOAD_IMAGES_FAILED = "UPLOAD_IMAGES_FAILED"

export const UPLOAD_VIDEOS = "UPLOAD_VIDEOS"
export const UPLOAD_VIDEOS_SUCCESS = "UPLOAD_VIDEOS_SUCCESS"
export const UPLOAD_VIDEOS_FAILED = "UPLOAD_VIDEOS_FAILED"

export const SEND_CHAT_NOTIFICATION = "SEND_CHAT_NOTIFICATION"
export const SET_SESSION_STATUS = "SET_SESSION_STATUS"

export const GET_COMMENT_BOARD_LIST = "GET_COMMENT_BOARD_LIST"
export const GET_COMMENT_BOARD_LIST_SUCCESS = "GET_COMMENT_BOARD_LIST_SUCCESS"
export const GET_COMMENT_BOARD_LIST_FAILED = "GET_COMMENT_BOARD_LIST_FAILED"
export const RESET_COMMENT_BOARD_LIST = "RESET_COMMENT_BOARD_LIST"

export const SEND_MESSAGE_WITH_MEDIA = "SEND_MESSAGE_WITH_MEDIA"
export const SEND_MESSAGE_WITH_MEDIA_SUCCESS = "SEND_MESSAGE_WITH_MEDIA_SUCCESS"
export const SEND_MESSAGE_WITH_MEDIA_FAILED = "SEND_MESSAGE_WITH_MEDIA_FAILED"
